/**
 * Вход в админку. Отдельный контур: `/admin/auth/login`, свой секрет,
 * свой audience, TTL 8 часов. Игрового входа в этой сборке нет вовсе.
 */

import { useState } from 'react'
import { ApiError, request, setToken } from '../api/client.js'
import type { LoginResponse } from '../api/types.js'

export interface LoginProps {
  onSuccess: () => void
}

export function Login({ onSuccess }: LoginProps): JSX.Element {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: React.FormEvent): Promise<void> {
    event.preventDefault()
    setBusy(true)
    setError(null)

    try {
      const session = await request<LoginResponse>('/admin/auth/login', {
        method: 'POST',
        body: { email, password },
        // 401 здесь означает «пара не подошла», а не «сессия истекла»:
        // сбрасывать нечего, и обработчик протухшего токена звать незачем.
        keepSessionOn401: true,
      })
      setToken(session.accessToken)
      onSuccess()
    } catch (err) {
      if (err instanceof ApiError && err.status === 429) {
        setError('Too many sign-in attempts. Wait a minute.')
      } else {
        setError(err instanceof Error ? err.message : String(err))
      }
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="shell">
      <form className="card login" onSubmit={(e) => void submit(e)}>
        <h1>
          LiveOps <span style={{ color: 'var(--accent)' }}>console</span>
        </h1>
        <p>Lust Arena — economy, players, cheat log</p>

        <label className="field">
          <span className="field__label">Email</span>
          <input
            className="input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <label className="field">
          <span className="field__label">Password</span>
          <input
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error !== null && <div className="notice notice--error">{error}</div>}

        <button className="btn btn--primary" type="submit" disabled={busy}>
          {busy ? 'Checking…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
